import { useQuery } from 'react-query';
import api from '../../utils/api';

import { VIDEO_LANDING } from '../../constants/endpoints';
import { VIDEO_LANDING_PAGE_DATA } from './queries';

const getVideoLandingPage = ({ mediaId }) => api.get(`${VIDEO_LANDING}/${mediaId}`);

export const useGetVideoLandingPage = ({ mediaId }) => {
  return useQuery([VIDEO_LANDING_PAGE_DATA], () => getVideoLandingPage({ mediaId }));
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useVideoLandingPageData.js